"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../Button"));

require("./button-group.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ButtonGroup = function ButtonGroup(_ref) {
  var className = _ref.className,
      options = _ref.options,
      selectedValue = _ref.selectedValue,
      onChange = _ref.onChange,
      selectedColor = _ref.selectedColor;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)('btn-group', className)
  }, options.map(function (option) {
    var className = option.className,
        style = option.style,
        label = option.label,
        value = option.value,
        _onClick = option.onClick,
        rest = _objectWithoutProperties(option, ["className", "style", "label", "value", "onClick"]);

    var isSelected = value === selectedValue;

    var computedStyle = _objectSpread({
      borderColor: isSelected ? null : '#E0E0E0'
    }, style);

    return _react.default.createElement(_Button.default, _extends({
      key: value,
      className: className,
      style: computedStyle,
      variant: isSelected ? 'solid' : 'outlined',
      color: isSelected ? selectedColor : 'gray-medium-dark',
      borderRadius: null,
      onClick: function onClick() {
        onChange(value);
        if (_onClick) _onClick(value);
      }
    }, rest), label);
  }));
};

ButtonGroup.propTypes = {
  className: _propTypes.default.string,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    className: _propTypes.default.string,
    style: _propTypes.default.string,
    label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
    value: _propTypes.default.string.isRequired
  })).isRequired,
  selectedValue: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired,
  selectedColor: _propTypes.default.string
};
ButtonGroup.defaultProps = {
  className: '',
  selectedColor: 'primary'
};
var _default = ButtonGroup;
exports.default = _default;